import { useState } from "react"
import { siteConfig } from "@/components/homepage/_config"
import { CornerPlus } from "@/components/ui/corner-plus"
import { HeaderBadge } from "@/components/homepage/ui/HeaderBadge"
import { HomepageChatbox } from "@/components/homepage/HomepageChatbox"
import { AuthModal } from "@/components/auth/AuthModal"
import type { AuthMode } from "@/components/auth/AuthForm"

export function Hero() {
    const { hero } = siteConfig
    const [modalOpen, setModalOpen] = useState(false)
    const [mode, setMode] = useState<AuthMode>('signup')

    const handleChatboxSubmit = (message: string) => {
        localStorage.setItem('pendingHomepagePrompt', message)
        setMode('signup')
        setModalOpen(true)
    }

    return (
        <section
            id="hero"
            className="relative flex flex-col items-center justify-center px-4 py-32 md:py-52"
        >
            <CornerPlus position="bottom-left" className="text-muted-foreground/50" />
            <CornerPlus position="bottom-right" className="text-muted-foreground/50" />
            <div className="absolute inset-0 z-0 h-full w-full bg-radial-[at_45%_85%] from-[#2CD5FF]/25 via-[#2C30FF]/3 mask-[linear-gradient(to_bottom,transparent,black_100%)]" />
            <div className="absolute inset-0 z-0 h-full w-full bg-radial-[at_45%_68%] from-[#2CD5FF]/45 via-[#2C30FF]/2 mask-[linear-gradient(to_bottom,transparent,black_100%)] blur-[50px]" />
            <div className="relative z-10 flex flex-col items-center justify-center text-center space-y-6 max-w-4xl mx-auto">
                {hero.badge && <HeaderBadge icon={hero.badgeIcon} text={hero.badge} className="max-[350px]:hidden" />}
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tighter text-balance">
                    {hero.title}
                </h1>
                <p className="text-secondary-foreground/70 text-center text-balance text-lg max-w-2xl mx-auto">
                    {hero.description}
                </p>
                <div className="w-full pt-2">
                    <HomepageChatbox onSubmit={handleChatboxSubmit} />
                </div>
            </div>
            <AuthModal
                open={modalOpen}
                mode={mode}
                onOpenChange={setModalOpen}
                onModeChange={setMode}
            />
        </section>
    )
}
